





















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Modal from "@/components/form/Modal.vue";

@Component({ components: { Modal } })
export default class CFileManagerMenuItem extends Vue {
  @Prop({ default: false }) noDropDown!: boolean;
  @Prop() defaultState!: boolean;
  @Prop() iconClass!: string;
  @Prop() event!: Function;
  @Prop({ required: true }) title!: string;
  state: boolean = this.defaultState ? this.defaultState : false;

  @Watch("defaultState")
  checkDefaultState() {
    this.state = this.defaultState;
  }
}
